import './hmr'

import throttle from 'lodash/throttle'
import { gsap } from 'gsap'

import '../scss/app.scss'

const smallHeaderClass = 'small-header'
const smallHeaderThreshold = 200

const logoBulk = document.getElementById('js-logo-bulk')
const logoSwoosh = document.getElementById('js-logo-swoosh')
const logoTL = gsap.timeline({ paused: true, defaults: { ease: 'power2.out' } })
logoTL.to(logoSwoosh, { scale: 6, x: '-130px', y: '-70px' }, 0)
logoTL.to(logoBulk, { opacity: 0 }, 0)

function resizeHeader() {
  if (window.pageYOffset > smallHeaderThreshold) {
    logoTL.timeScale(1).play()
    document.body.classList.add(smallHeaderClass)
  } else {
    logoTL.timeScale(3).reverse()
    document.body.classList.remove(smallHeaderClass)
  }
}

if (!document.body.classList.contains('disable-logo-anim')) {
  resizeHeader()
  window.addEventListener('scroll', throttle(resizeHeader, 100))
}
